import Vue from "vue";
import Vuex from "vuex";
import commonStore from "./commonStore";
import mobile from './mobile'

Vue.use(Vuex);

export default () =>
  new Vuex.Store({
    modules: { commonStore, mobile }
  });
